export default __webpack_public_path__ + "static/media/PT-Root-UI_Medium.dab54de6.woff";